// connectionSlice.ts

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { } from '../../interfaces';
import { app, page, slice } from '../../enums';
import { copyToClipboard } from '../../utils';

/**
 * Represents the state of the application.
 * @interface
 * @description Contains various properties to manage the application state.
 * @usage This interface is used to define the shape of the Redux state in the application.
 */
export interface AppState {
    /** The version of the application. */
    appVersion: number | string;


    copiedItem: string;
    /** Indicates whether local storage is enabled. */
    enableLocal: boolean;

    /** The current application being used. */
    currentApp: app;

    /** The current page being displayed. */
    currentPage: page | null;

    /** Indicates whether all the application requirements are loaded, allowing the application to start. */
    isAppLoading: boolean;

}
// Define initial state for the connection slice
const initialState: AppState = {
    copiedItem: '',

    // Whether to enable local storage
    enableLocal: true,

    // Application version
    appVersion: import.meta.env.VITE_VERSION || 'N/A',
    // Current page
    currentPage: null,
    // Flag to indicate if the app is loading
    isAppLoading: true,
    // Required variables for the app

    currentApp: 0
};

// Define the connection slice with reducers
const connectionSlice = createSlice({
  // Name of the slice
  name: slice.APP,
  // Initial state
  initialState,
  // Reducer functions to modify state
  reducers: {
    // Set the current app
    setCurrentApp: (state, action: PayloadAction<app>) => {
      state.currentApp = action.payload;
    },

 

    copyItem:(state, action: PayloadAction<string>) => {
      copyToClipboard(action.payload);
      state.copiedItem = action.payload;
    },
    // Set the loading state of the app
    setIsAppLoading: (state, action: PayloadAction<boolean>) => {
      state.isAppLoading = action.payload;
    }, 
    // Set the current page
    setCurrentPage: (state, action: PayloadAction<page>) => {
      state.currentPage = action.payload;
    },

  },
});

// Export action creators and reducer
export const {
  setCurrentApp,
  copyItem,
  setCurrentPage,
  setIsAppLoading,
} = connectionSlice.actions;

export default connectionSlice.reducer;
